import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.espresso1,
        name: "Guatemalan",
        price: 4.95,
        disprice: 3.95,
        stock: 10,
        content: "Medium roast with milk chocolate notes that ease into a sweet orange citrus finish.",
        description: "Guatemalan coffee is a medium roast featuring initial notes of milk chocolate that gracefully transition into a sweet orange mild citrus finish. It creates an absolutely delectable cup.",
        category: ["Hot Coffee", "Coffee Specials"],
        tags: ["coffee", "hot coffee", "medium roast"],
        gallery: {
            image1: images.espresso1,
            image2: images.espresso2,
            image3: images.espresso4,
            image4: images.espresso7,
        },
        addInfo: [
            { id: 1, title: "Sizes", content: "12oz / 16oz" },
            { id: 2, title: "Roast", content: "Medium Roast" },
            { id: 3, title: "Flavor Notes", content: "Milk Chocolate, Sweet Orange, Mild Citrus" },
            { id: 4, title: "Best Paired With", content: "Croissant" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Emily Carter",
                date: "July 10, 2025",
                rating: 5,
                content: "Absolutely delicious! Soft, fresh, and the frosting is heavenly."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Daniel Brooks",
                date: "July 12, 2025",
                rating: 4.5,
                content: "Smooth, bright, and great with a croissant. Will order again!"
            }
        ]
    },
    {
        id: 2,
        image: images.espresso2,
        name: "Colombian",
        price: 4.95,
        disprice: 3.95,
        stock: 8,
        content: "Silky smooth Colombian coffee with almond, chocolate, and a bright citrus finish.",
        description: "Colombian coffee is a real standout. It has a silky smooth body with lovely notes of almond and chocolate, finishing with a bright little hint of citrus.",
        category: ["Hot Coffee", "Coffee Specials"],
        tags: ["coffee", "hot coffee", "smooth"],
        gallery: {
            image1: images.espresso2,
            image2: images.espresso1,
            image3: images.espresso4,
            image4: images.espresso8,
        },
        addInfo: [
            { id: 1, title: "Sizes", content: "12oz / 16oz" },
            { id: 2, title: "Body", content: "Silky Smooth" },
            { id: 3, title: "Flavor Notes", content: "Almond, Chocolate, Citrus" },
            { id: 4, title: "Best Pairing", content: "Croissant" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Liam Wright",
                date: "July 14, 2025",
                rating: 5,
                content: "Smooth body and a bright finish. My daily favorite!"
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Olivia Martinez",
                date: "July 15, 2025",
                rating: 4.5,
                content: "Full of flavor. Highly recommend with a croissant."
            }
        ]
    },
    {
        id: 3,
        image: images.espresso4,
        name: "Costa Rican Tarrazu",
        price: 4.95,
        disprice: 3.95,
        stock: 4,
        content: "Medium roast with bright acidity, sweet honey, chocolate, and a full-flavored finish.",
        description: "Costa Rican Tarrazu coffee is a medium roast that possesses an intense flavor with peaks of bright acidity and depths of sweet honey and chocolate.",
        category: ["Hot Coffee", "Coffee Specials"],
        tags: ["coffee", "hot coffee", "medium roast"],
        gallery: {
            image1: images.espresso4,
            image2: images.espresso2,
            image3: images.espresso1,
            image4: images.espresso7,
        },
        addInfo: [
            { id: 1, title: "Sizes", content: "12oz / 16oz" },
            { id: 2, title: "Roast", content: "Medium Roast" },
            { id: 3, title: "Flavor Notes", content: "Bright Acidity, Honey, Chocolate" },
            { id: 4, title: "Best Pairing", content: "Croissant" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Ella Thompson",
                date: "July 14, 2025",
                rating: 5,
                content: "Bright, sweet, and full of flavor. Pairs perfectly with a croissant!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Noah Patel",
                date: "July 15, 2025",
                rating: 4.5,
                content: "A great pick when I want a smooth hot coffee."
            }
        ]
    },
    {
        id: 4,
        image: images.espresso7,
        name: "Black Knight",
        price: 4.95,
        disprice: 3.95,
        stock: 12,
        content: "Dangerously dark roast with tropical plantain notes and intense caramelized sugar.",
        description: "Looking for a coffee that's truly bold? Black Knight is a dark roast blend with notorious notes of tropical plantains and intense caramelized sugar.",
        category: ["Hot Coffee", "Coffee Specials"],
        tags: ["coffee", "hot coffee", "dark roast"],
        gallery: {
            image1: images.espresso7,
            image2: images.espresso4,
            image3: images.espresso2,
            image4: images.espresso8,
        },
        addInfo: [
            { id: 1, title: "Sizes", content: "12oz / 16oz" },
            { id: 2, title: "Roast", content: "Dark Roast" },
            { id: 3, title: "Flavor Notes", content: "Tropical Plantain, Caramelized Sugar" },
            { id: 4, title: "Best Served", content: "Hot" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Daniel Brooks",
                date: "July 15, 2025",
                rating: 5,
                content: "Bold and satisfying. My go-to coffee every day!"
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Maya Ali",
                date: "July 16, 2025",
                rating: 4.5,
                content: "Loved the dark roast flavor and sweet finish."
            }
        ]
    },
    {
        id: 5,
        image: images.espresso8,
        name: "Italian Espresso",
        price: 4.95,
        disprice: 3.95,
        stock: 9,
        content: "Dark roast with red fruit notes, dense bittersweet body, and a rich tangy finish.",
        description: "Italian Espresso is a dark roast with notes of red fruits and a dense, bittersweet body. This artisan blend is rich, tangy, and made for dark roast lovers.",
        category: ["Hot Coffee", "Coffee Specials"],
        tags: ["coffee", "hot coffee", "espresso"],
        gallery: {
            image1: images.espresso8,
            image2: images.espresso7,
            image3: images.espresso4,
            image4: images.espresso2,
        },
        addInfo: [
            { id: 1, title: "Sizes", content: "12oz / 16oz" },
            { id: 2, title: "Roast", content: "Dark Roast" },
            { id: 3, title: "Flavor Notes", content: "Red Fruits, Bittersweet Body, Tangy Finish" },
            { id: 4, title: "Best Paired With", content: "Croissant" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Emily Stone",
                date: "July 15, 2025",
                rating: 5,
                content: "Absolutely delicious! Rich flavor and a deep roast profile."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Hamza Rehman",
                date: "July 16, 2025",
                rating: 4.8,
                content: "Perfect with a croissant. My favorite dark roast from the shop!"
            }
        ]
    },
    {
        id: 6,
        image: images.espresso5,
        name: "Jamaican Me Crazy",
        price: 4.95,
        disprice: 3.95,
        stock: 6,
        content: "Flavored coffee with sweet caramel, vanilla bean, and coffee liqueur notes.",
        description: "Jamaican Me Crazy flavored coffee brings sweet caramel, vanilla bean, and coffee liqueur flavors together for a bright, dessert-like cup.",
        category: ["Hot Coffee", "Coffee Specials"],
        tags: ["coffee", "hot coffee", "flavored"],
        gallery: {
            image1: images.espresso5,
            image2: images.espresso1,
            image3: images.espresso2,
            image4: images.espresso8,
        },
        addInfo: [
            { id: 1, title: "Sizes", content: "12oz / 16oz" },
            { id: 2, title: "Style", content: "Flavored Coffee" },
            { id: 3, title: "Flavor Notes", content: "Caramel, Vanilla Bean, Coffee Liqueur" },
            { id: 4, title: "Best Served", content: "Hot" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Ayesha Malik",
                date: "July 12, 2025",
                rating: 5,
                content: "Sweet, smooth, and the perfect pick-me-up."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Daniel Cruz",
                date: "July 13, 2025",
                rating: 4.7,
                content: "Delicious and comforting. The caramel notes are great."
            }
        ]
    },
    {
        id: 7,
        image: images.dessert1,
        name: "Croissant",
        price: 5.00,
        disprice: 2.00,
        stock: 3,
        content: "Fresh baked croissant with buttery, flaky layers - perfect with hot coffee.",
        description: "Savor the classic taste of our freshly baked Croissant. Light, airy layers with a golden crust make it the ideal companion to the hot coffee menu.",
        category: ["Pastries", "Baked Goods", "Sweet Snacks"],
        tags: ["croissant", "pastry", "baked"],
        gallery: {
            image1: images.dessert1,
            image2: images.product7Gallery1,
            image3: images.sweet1,
            image4: images.product7Gallery2,
        },
        addInfo: [
            { id: 1, title: "Serving Size", content: "1 Piece" },
            { id: 2, title: "Texture", content: "Flaky and Buttery" },
            { id: 3, title: "Price Range", content: "$2.00 - $5.00" },
            { id: 4, title: "Best Paired With", content: "Guatemalan, Colombian, Italian Espresso" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Emma Shah",
                date: "July 14, 2025",
                rating: 4.8,
                content: "Crispy on the outside and soft inside—just how a croissant should be!"
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Michael Lee",
                date: "July 15, 2025",
                rating: 5,
                content: "Pairs perfectly with hot coffee. Tastes like Paris!"
            }
        ]
    },
    {
        id: 8,
        image: images.espresso6,
        name: "Breakfast Blend",
        price: 4.95,
        disprice: 3.95,
        stock: 10,
        content: "Light artisan roast crafted to be flavorful, rich, and balanced on the palate.",
        description: "Breakfast Blend is designed to delight, not overwhelm. This light artisan roast offers a flavorful and rich experience that feels wonderfully balanced on the palate.",
        category: ["Hot Coffee", "Coffee Specials"],
        tags: ["coffee", "hot coffee", "light roast"],
        gallery: {
            image1: images.espresso6,
            image2: images.espresso2,
            image3: images.espresso1,
            image4: images.espresso4,
        },
        addInfo: [
            { id: 1, title: "Sizes", content: "12oz / 16oz" },
            { id: 2, title: "Roast", content: "Light Roast" },
            { id: 3, title: "Flavor Notes", content: "Balanced, Flavorful, Rich" },
            { id: 4, title: "Best Paired With", content: "Croissant" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Sara Iqbal",
                date: "July 15, 2025",
                rating: 4.7,
                content: "Light, balanced, and definitely my go-to morning cup!"
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "David Kim",
                date: "July 16, 2025",
                rating: 4.9,
                content: "Great quality coffee. Helps me stay focused at work."
            }
        ]
    },
    {
        id: 9,
        image: images.bottledWater,
        name: "Bottle Water",
        price: 1.50,
        disprice: 1.50,
        stock: 22,
        content: "Chilled bottled water from the cold drinks menu.",
        description: "Chilled bottled water, ready to pair with pastries, hot coffee, or any cold drink order.",
        category: ["Cold Treats", "Cold Coffee"],
        tags: ["cold drink", "water"],
        gallery: {
            image1: images.bottledWater,
            image2: images.coldBrew1,
            image3: images.coldBrew3,
            image4: images.coldBrew4,
        },
        addInfo: [
            { id: 1, title: "Serving", content: "Bottle" },
            { id: 2, title: "Menu Section", content: "Cold Coffee" },
            { id: 3, title: "Best Paired With", content: "Croissant" },
            { id: 4, title: "Served", content: "Chilled" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Ayesha Khan",
                date: "July 14, 2025",
                rating: 5,
                content: "Cold and convenient with my pastry order."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Mark Spencer",
                date: "July 15, 2025",
                rating: 4.8,
                content: "Simple, chilled, and exactly what I needed."
            }
        ]
    },
    {
        id: 10,
        image: images.coldBrew1,
        name: "Iced Coffee",
        price: 4.95,
        disprice: 4.95,
        stock: 18,
        content: "16oz iced coffee served chilled and customizable with syrup add-ins.",
        description: "Our 16oz Iced Coffee is served chilled and can be customized with coffee syrups for your preferred flavor.",
        category: ["Cold Treats", "Cold Coffee"],
        tags: ["iced coffee", "cold drink", "coffee"],
        gallery: {
            image1: images.coldBrew1,
            image2: images.coldBrew2,
            image3: images.coldBrew6,
            image4: images.coldBrew4,
        },
        addInfo: [
            { id: 1, title: "Size", content: "16oz" },
            { id: 2, title: "Menu Section", content: "Cold Coffee" },
            { id: 3, title: "Customize", content: "Coffee Syrups Available" },
            { id: 4, title: "Served", content: "Over Ice" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Emily Rose",
                date: "July 15, 2025",
                rating: 5,
                content: "Cold, smooth, and great with caramel syrup."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Jason Malik",
                date: "July 16, 2025",
                rating: 4.7,
                content: "Refreshing coffee flavor. Will buy again!"
            }
        ]
    },
    {
        id: 11,
        image: images.coldBrew3,
        name: "Ice Tea",
        price: 2.25,
        disprice: 2.25,
        stock: 25,
        content: "16oz refreshing iced tea from the cold drinks menu.",
        description: "A refreshing 16oz iced tea, served cold as part of the updated Cold Coffee menu.",
        category: ["Cold Treats", "Cold Coffee"],
        tags: ["iced tea", "cold drink"],
        gallery: {
            image1: images.coldBrew3,
            image2: images.coldBrew2,
            image3: images.coldBrew4,
            image4: images.coldBrew6,
        },
        addInfo: [
            { id: 1, title: "Size", content: "16oz" },
            { id: 2, title: "Menu Section", content: "Cold Coffee" },
            { id: 3, title: "Best Paired With", content: "Croissant" },
            { id: 4, title: "Served", content: "Chilled" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Daniel Craig",
                date: "July 15, 2025",
                rating: 4.8,
                content: "Light and refreshing with my lunch order."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Sophia Karim",
                date: "July 16, 2025",
                rating: 5,
                content: "Cold and crisp. My go-to afternoon drink."
            }
        ]
    },
    {
        id: 12,
        image: images.coldBrew4,
        name: "Smoothie",
        price: 6.50,
        disprice: 6.50,
        stock: 30,
        content: "16oz smoothie available in Strawberry, Banana, Mango, Peach, and Pina Colada.",
        description: "Our 16oz Smoothie comes in Strawberry, Banana, Mango, Peach, and Pina Colada flavors, with whey protein available as an add-in.",
        category: ["Cold Treats", "Cold Coffee"],
        tags: ["smoothie", "cold drink"],
        gallery: {
            image1: images.coldBrew4,
            image2: images.coldBrew5,
            image3: images.coldBrew6,
            image4: images.coldBrew7,
        },
        addInfo: [
            { id: 1, title: "Size", content: "16oz" },
            { id: 2, title: "Flavors", content: "Strawberry, Banana, Mango, Peach, Pina Colada" },
            { id: 3, title: "Add-In", content: "Whey Protein Available" },
            { id: 4, title: "Served", content: "Blended Cold" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Michael Tran",
                date: "July 15, 2025",
                rating: 5,
                content: "The mango smoothie is bright and refreshing."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Emily Rivers",
                date: "July 16, 2025",
                rating: 4.7,
                content: "Fresh, cold, and delicious!"
            }
        ]
    },
    {
        id: 13,
        image: images.coldBrew5,
        name: "Whey Protein Add-In",
        price: 2.00,
        disprice: 2.00,
        stock: 25,
        content: "Add whey protein to any smoothie from the cold drinks menu.",
        description: "Boost any smoothie with a whey protein add-in for an extra $2.00.",
        category: ["Cold Treats", "Cold Coffee"],
        tags: ["smoothie add-in", "protein", "cold drink"],
        gallery: {
            image1: images.coldBrew5,
            image2: images.coldBrew4,
            image3: images.coldBrew6,
            image4: images.coldBrew7,
        },
        addInfo: [
            { id: 1, title: "Add-In Price", content: "$2.00" },
            { id: 2, title: "For", content: "Smoothies" },
            { id: 3, title: "Menu Section", content: "Cold Coffee" },
            { id: 4, title: "Serving", content: "Blended Into Smoothie" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Aria Williams",
                date: "July 15, 2025",
                rating: 5,
                content: "Great add-in for the banana smoothie."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "David Park",
                date: "July 16, 2025",
                rating: 4.8,
                content: "Easy way to make the smoothie more filling."
            }
        ]
    },
    {
        id: 14,
        image: images.coffeeSyrups,
        name: "Coffee Syrups",
        price: 0.50,
        disprice: 0.50,
        stock: 20,
        content: "Extra syrup pump for coffee and cold drinks.",
        description: "Coffee syrups are available for an extra $0.50 per pump. Options include Vanilla, Hazelnut, Caramel, Raspberry, Lavender, Peppermint, Strawberry, Cinnamon, and more.",
        category: ["Cold Treats", "Cold Coffee"],
        tags: ["syrup", "coffee add-in", "cold drink"],
        gallery: {
            image1: images.coffeeSyrups,
            image2: images.coldBrew2,
            image3: images.coldBrew4,
            image4: images.coldBrew8,
        },
        addInfo: [
            { id: 1, title: "Add-On Price", content: "$0.50 Extra Pump" },
            { id: 2, title: "Popular Flavors", content: "Vanilla, Hazelnut, Caramel, Raspberry" },
            { id: 3, title: "More Options", content: "Lavender, Peppermint, Strawberry, Cinnamon" },
            { id: 4, title: "Works With", content: "Iced Coffee" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Lena Smith",
                date: "July 15, 2025",
                rating: 5,
                content: "Caramel syrup in iced coffee is my favorite."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Marcus Allen",
                date: "July 16, 2025",
                rating: 4.7,
                content: "Great flavor options for cold coffee."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Hot Cocoa",
        price: 15,
        disprice: 12,
        stock: 25,
        content: "Smooth and comforting hot cocoa made with rich cocoa powder and creamy milk — perfect for chilly days.",
        description: "Warm up with our Hot Cocoa, a classic beverage crafted from high-quality cocoa and steamed milk. Topped with whipped cream or marshmallows for extra indulgence, it's a cozy drink that soothes the soul and delights your taste buds, any time of day.",
        category: ["Hot Beverages"],
        tags: ["cocoa", "hotdrink", "sweet"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Cocoa Type", content: "Rich Dutch-processed" },
            { id: 2, title: "Toppings", content: "Whipped Cream / Marshmallows" },
            { id: 3, title: "Serving Temp", content: "Hot" },
            { id: 4, title: "Sweetness", content: "Medium" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Jasmine Cole",
                date: "July 15, 2025",
                rating: 5,
                content: "Perfectly creamy and not too sweet. Great for relaxing evenings."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Ethan Moore",
                date: "July 16, 2025",
                rating: 4.8,
                content: "A comfort drink done right. I always add marshmallows!"
            }
        ]
    }

];

export default products;
